import { BrowserRouter, useLocation } from "react-router-dom";
import { Suspense, useEffect, useLayoutEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useCart } from "./hooks/useCart";
import { CartContext } from "./hooks/CartContext";
import { AuthProvider } from "./hooks/AuthContext";
import { AppEnvironmentProvider } from "./hooks/AppEnvironmentContext";
import { useTelegramBackButton } from "./hooks/useTelegramBackButton";
import Layout from "./components/feature/Layout";
import { trackSiteVisit } from "./lib/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    document.body.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function AppContent() {
  useTelegramBackButton();

  const {
    cart,
    isOpen,
    setIsOpen,
    addItem,
    removeItem,
    updateQuantity,
    clearCart,
  } = useCart();

  useEffect(() => {
    trackSiteVisit();
  }, []);

  return (
    <AuthProvider>
      <CartContext.Provider value={{ cart, addItem, removeItem, updateQuantity, clearCart }}>
        <Layout
          cart={cart}
          cartOpen={isOpen}
          onCartToggle={() => setIsOpen((v) => !v)}
          onCartClose={() => setIsOpen(false)}
          onCartRemove={removeItem}
          onCartUpdateQuantity={updateQuantity}
        >
          <ScrollToTop />
          <Suspense
            fallback={
              <div className="flex min-h-[50vh] items-center justify-center px-4 text-sm font-medium text-dark/45">
                Загружаем...
              </div>
            }
          >
            <AppRoutes />
          </Suspense>
        </Layout>
      </CartContext.Provider>
    </AuthProvider>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AppEnvironmentProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppContent />
        </BrowserRouter>
      </AppEnvironmentProvider>
    </I18nextProvider>
  );
}

export default App;
